import { intervalToDuration } from 'date-fns';

const justLoggedIn = ({ start, end }: { start: Date; end: Date }) => {
  const { hours = 0, minutes = 0, seconds = 0 } = intervalToDuration({ start, end });

  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  return totalSeconds < 20;
};

export { justLoggedIn };
